import { render, staticRenderFns } from "./social-signin.vue?vue&type=template&id=447273c8&scoped=true&"
import script from "./social-signin.vue?vue&type=script&lang=js&"
export * from "./social-signin.vue?vue&type=script&lang=js&"
import style0 from "./social-signin.vue?vue&type=style&index=0&id=447273c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447273c8",
  null
  
)

export default component.exports